import PollMessage from "./PollMessage";

export default PollMessage;
